// enums.js — Central option lists for all Admin modals.

// F1 — institution_type
export const INSTITUTION_TYPES = [
  { value: 'federal_ministry',    label: 'Federal Ministry' },
  { value: 'state_authority',     label: 'State Authority' },
  { value: 'lga_authority',       label: 'LGA Authority' },
  { value: 'partner_organisation',label: 'Partner Organisation' },
  { value: 'external_agency',     label: 'External Agency' },
  { value: 'private_sector',      label: 'Private Sector' },
];

// F3 — role scopes
export const ROLE_SCOPES = [
  { value: 'platform_wide',        label: 'Platform Wide' },
  { value: 'cross_domain',         label: 'Cross Domain' },
  { value: 'domain_specific',      label: 'Domain Specific' },
  { value: 'jurisdiction_limited', label: 'Jurisdiction Limited' },
  { value: 'programme_specific',   label: 'Programme Specific' },
  { value: 'read_only',            label: 'Read Only' },
];

// F2 — user roles (mirrors rbacConfig ROLES)
export const USER_ROLES = [
  { value: 'R01', label: 'System Administrator' },
  { value: 'R02', label: 'National Data Manager' },
  { value: 'R03', label: 'Federal Department Officer' },
  { value: 'R04', label: 'State Data Officer' },
  { value: 'R05', label: 'LGA Field Officer' },
  { value: 'R06', label: 'External Viewer' },
];

// F2 — user_type
export const USER_TYPES = [
  { value: 'system_admin',  label: 'System Admin' },
  { value: 'standard_user', label: 'Standard User' },
  { value: 'field_officer', label: 'Field Officer' },
  { value: 'read_only',     label: 'Read Only' },
  { value: 'external',      label: 'External' },
];

// F5 — ecological_zone
export const ECOLOGICAL_ZONES = [
  { value: 'sahel',           label: 'Sahel' },
  { value: 'sudan_savanna',   label: 'Sudan savanna' },
  { value: 'guinea_savanna',  label: 'Guinea savanna' },
  { value: 'derived_savanna', label: 'Derived savanna' },
  { value: 'rainforest',      label: 'Rainforest' },
  { value: 'mangrove',        label: 'Mangrove' },
];

// Nigerian states list (for geospatial)
export const NIGERIAN_STATES = [
  'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa','Benue','Borno',
  'Cross River','Delta','Ebonyi','Edo','Ekiti','Enugu','FCT','Gombe','Imo',
  'Jigawa','Kaduna','Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa',
  'Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers','Sokoto','Taraba','Yobe','Zamfara',
].map(s => ({ value: s, label: s }));

// F7 — source_organisation
export const SOURCE_ORGANISATIONS = [
  { value: 'NBS',     label: 'NBS' },
  { value: 'CBN',     label: 'CBN' },
  { value: 'FAO',     label: 'FAO' },
  { value: 'WHO',     label: 'WHO' },
  { value: 'CUSTOMS', label: 'CUSTOMS' },
  { value: 'OTHER',   label: 'OTHER' },
];

// F7 — geographic_scope
export const GEOGRAPHIC_SCOPES = [
  { value: 'national', label: 'National' },
  { value: 'state',    label: 'State' },
];

// F7 — data_status
export const DATA_STATUSES = [
  { value: 'draft',     label: 'Draft' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'validated', label: 'Validated' },
  { value: 'approved',  label: 'Approved' },
  { value: 'rejected',  label: 'Rejected' },
];

// F8a — species_category
export const SPECIES_CATEGORIES = [
  { value: 'ruminant_large',  label: 'Ruminant Large' },
  { value: 'ruminant_small',  label: 'Ruminant small' },
  { value: 'monogastric',     label: 'Monogastric' },
  { value: 'poultry',         label: 'Poultry' },
  { value: 'equine',          label: 'Equine' },
  { value: 'apiculture',      label: 'Apiculture' },
  { value: 'micro_livestock', label: 'Micro livestock' },
  { value: 'aquaculture',     label: 'Aquaculture' },
];

// F8a — mandate_status
export const MANDATE_STATUSES = [
  { value: 'active',    label: 'Active' },
  { value: 'reserved',  label: 'Reserved' },
  { value: 'excluded',  label: 'Excluded' },
];

// F8b — genetic_type
export const GENETIC_TYPES = [
  { value: 'indigenous', label: 'Indigenous' },
  { value: 'exotic',     label: 'Exotic' },
  { value: 'crossbred',  label: 'Crossbred' },
  { value: 'synthetic',  label: 'Synthetic' },
];

// F8b — primary_production_trait
export const PRIMARY_PRODUCTION_TRAITS = [
  { value: 'beef',         label: 'Beef' },
  { value: 'dairy',        label: 'Dairy' },
  { value: 'dual_purpose', label: 'Dual-purpose' },
  { value: 'draught',      label: 'Draught' },
  { value: 'egg',          label: 'Egg' },
  { value: 'meat',         label: 'Meat' },
  { value: 'fibre',        label: 'Fibre' },
  { value: 'honey',        label: 'Honey' },
  { value: 'other',        label: 'Other' },
];

// F8c — purpose_label options (flat list; backend will filter by species)
export const PURPOSE_LABELS = [
  { value: 'beef',               label: 'Beef' },
  { value: 'dairy',              label: 'Dairy' },
  { value: 'dual_purpose',       label: 'Dual-purpose' },
  { value: 'breeding',           label: 'Breeding' },
  { value: 'draught',            label: 'Draught' },
  { value: 'meat',               label: 'Meat' },
  { value: 'festival_fattening', label: 'Festival Fattening' },
  { value: 'egg_commercial',     label: 'Egg Production (Commercial)' },
  { value: 'broiler_meat',       label: 'Broiler Meat' },
  { value: 'honey',              label: 'Honey' },
  { value: 'pollination',        label: 'Pollination' },
  { value: 'beeswax',            label: 'Beeswax' },
  { value: 'fur',                label: 'Fur' },
];

// F8d — age_class_label options (flat list; backend will filter by species)
export const AGE_CLASS_LABELS = [
  { value: 'calf_under6mo',    label: 'Calf <6mo' },
  { value: 'weaner_6to12mo',   label: 'Weaner 6–12mo' },
  { value: 'yearling_1to2yr',  label: 'Yearling 1–2yr' },
  { value: 'adult',            label: 'Adult' },
  { value: 'aged',             label: 'Aged' },
  { value: 'kid_under3mo',     label: 'Kid <3mo' },
  { value: 'lamb_under3mo',    label: 'Lamb <3mo' },
  { value: 'weaner_3to6mo',    label: 'Weaner 3–6mo' },
  { value: 'yearling_6to12mo', label: 'Yearling 6–12mo' },
  { value: 'buck',             label: 'Buck / Breeding Male' },
  { value: 'ram',              label: 'Ram' },
  { value: 'piglet',           label: 'Piglet' },
  { value: 'grower',           label: 'Grower' },
  { value: 'finisher',         label: 'Finisher' },
  { value: 'breeding_sow',     label: 'Breeding Sow' },
  { value: 'boar',             label: 'Boar' },
  { value: 'day_old',          label: 'Day-old' },
  { value: 'grower_wk1_3',     label: 'Grower Wk 1–3' },
  { value: 'finisher_wk4_6',   label: 'Finisher Wk 4–6' },
  { value: 'market_weight',    label: 'Market Weight' },
  { value: 'pullet_wk1_17',    label: 'Pullet Wk 1–17' },
  { value: 'laying_wk18_72',   label: 'Laying Wk 18–72+' },
  { value: 'spent_hen',        label: 'Spent Hen' },
  { value: 'chick',            label: 'Chick' },
  { value: 'growing',          label: 'Growing' },
  { value: 'keet',             label: 'Keet' },
  { value: 'juvenile',         label: 'Juvenile' },
  { value: 'poult',            label: 'Poult' },
  { value: 'kit',              label: 'Kit' },
  { value: 'colony_hive',      label: 'Colony/Hive Count' },
];

// Audit log action labels (display only)
export const AUDIT_ACTION_LABELS = {
  CREATE: 'Record created', UPDATE: 'Record updated', SUBMIT: 'Submitted for review',
  VALIDATE: 'Validated', APPROVE: 'Approved', REJECT: 'Rejected',
  LOGIN: 'User login', EXPORT: 'Data exported', DELETE: 'Record deleted',
};
